import Organizations from './Organizations';

export const PAGE_ORGANISATIONS = '/organizations';

export default Organizations;
